import { useFilestack } from '@shared/utils/filestack';
import { useState } from 'react';

export function useFilePicker({ eventId, initialPhotoUrl }: { eventId: string; initialPhotoUrl?: string }) {
  const [updatedPhoto, setUpdatedPhoto] = useState<string | undefined>(initialPhotoUrl);
  const [photoFilename, setPhotoFilename] = useState<string | undefined>(undefined);
  const clearPhoto = () => {
    setUpdatedPhoto(undefined);
    setPhotoFilename(undefined);
  };

  const { open: openFilepicker, getPhotoPreviewUrl } = useFilestack({
    containerId: eventId,
    onUploadDone: async res => {
      const { filename, url } = res.filesUploaded[0];
      const photo = await getPhotoPreviewUrl({
        url
      });
      setUpdatedPhoto(photo);
      setPhotoFilename(filename);
    },
    maxFiles: 1
  });

  return {
    openFilepicker,
    clearPhoto,
    updatedPhoto,
    photoFilename
  };
}
